import {
  IconButton,
  InputGroup,
  InputProps,
  InputRightElement,
  useTheme,
} from '@chakra-ui/react';
import * as React from 'react';
import { useToggle } from 'react-use';
import Input from '~/components/Input';
import { ClosedEye, EyeIcon } from '~/components/icons';

interface Props extends InputProps {
  onChange: (event: React.ChangeEvent) => void;
  value?: string;
  size?: string;
}

const PasswordInput = React.forwardRef<HTMLInputElement, Props>(
  ({ size, ...props }, ref) => {
    const [isVisible, toggleVisible] = useToggle(false);
    const theme = useTheme();

    const inputSize = size || theme.components.Input.defaultProps.size;
    const inputHeight = theme.components.Input.sizes[inputSize].field.h;

    return (
      <InputGroup>
        <Input
          ref={ref}
          size={size}
          {...props}
          type={isVisible ? 'text' : 'password'}
        />
        <InputRightElement height={theme.space[inputHeight]}>
          <IconButton
            aria-label={isVisible ? 'Hide password' : 'Show password'}
            icon={
              isVisible ? (
                <ClosedEye width="14px" color="primary.400" />
              ) : (
                <EyeIcon width="14px" color="primary.400" />
              )
            }
            isRound
            onClick={toggleVisible}
            variant="transparent"
          />
        </InputRightElement>
      </InputGroup>
    );
  },
);

export default PasswordInput;
